export const GAME_LANUGAME = {
  215: {
    default: 'vi-VN',
    'vi-VN': {
      currencyTips:
        '1.Trị giá Thông Bảo: 1 Thông Bảo≈3000VND.</br>2.Thông bảo chưởng quỹ sẽ được gửi vào hòm thư của bạn, thánh toán gói hoặc nguyên bảo bằng Thông Bảo sẽ nhận được EXP VIP.',
      currencyType: 'Thông Bảo',
      coinType: 'Nguyên Bảo',
      maxExtraRatio: 'Nguyên Bảo Tăng $rate'
    },
    'en-US': {
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'ja-JP': {
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'ko-KR': {
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'th-TH': {
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  211: {
    default: 'ko-KR',
    'ko-KR': {
      currencyTips:
        '1. 사장 통보 가격: 180원≈1사장 통보.</br>2. 구입한 사장 통보는 우편으로 발송되며, 게임 내에서 임의의 패키지, 원보를 구입하는 데 사용됩니다. 사장 통보를 소모하면 해당 금액만큼 VIP 경험치를 획득합니다.',
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'en-US': {
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'ja-JP': {
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'th-TH': {
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  213: {
    default: 'en-US',
    'en-US': {
      currencyTips:
        "1. Worth of Trader Token: 0.14USD ≈ 1 Trader Token.</br>2. The Trader Tokens you've purchased will be sent via mail. It can be used to buy any packs and ingots in the game, granting you VIP EXP equal to the purchase amount.",
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'ko-KR': {
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'ja-JP': {
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'th-TH': {
      currencyTips:
        '1.มูลค่าเหรียญเถ้าแก่ : 0.14USD≈1 เหรียญเถ้าแก่</br>2.หลังซื้อเหรียญเถ้าแก่ ระบบจะส่งให้ทางอีเมล สามารถใช้ซื้อแพ็กและก้อนทองได้ และเมื่อใช้เหรียญเถ้าแก่ ก็จะได้รับ EXP VIP เช่นกัน',
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyTips:
        '1. Стоимость жетона торговца: 1 жетон торговца ≈ 0.14 USD</br>2. Купленные жетоны торговца будут отправлены на почту. Их можно будет использовать для покупки любых наборов и слитков, при этом вы будете получать эквивалентный покупке опыт VIP.',
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  209: {
    default: 'ja-JP',
    'ja-JP': {
      currencyTips:
        '1．商人通宝の価値：18円≈1商人通宝。</br>2．購入した商人通宝は手紙で送信されます。商人通宝を使用すると、ゲーム内で任意パック、元宝を購入できます。商人通宝を使用すると対応する値のVIP経験を獲得できます。',
      currencyType: '商人通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝　最大$rate増量'
    },
    'ko-KR': {
      currencyType: '사장 통보',
      coinType: '원보',
      maxExtraRatio: '원보 최대 $rate 추가'
    },
    'en-US': {
      currencyType: 'Trader Token',
      coinType: 'Ingots',
      maxExtraRatio: 'Up to $rate Extra Ingots'
    },
    'th-TH': {
      currencyType: 'เหรียญเถ้าแก่',
      coinType: 'ก้อนทอง',
      maxExtraRatio: 'โบนัสก้อนทองสูงสุด $rate'
    },
    'ru-RU': {
      currencyType: 'жетон торговца',
      coinType: 'Слиток'
    },
    'zh-TW': {
      currencyType: '掌櫃通寶',
      coinType: '元寶',
      maxExtraRatio: '元寶最高加碼$rate'
    },
    'zh-CN': {
      currencyType: '掌柜通宝',
      coinType: '元宝',
      maxExtraRatio: '元宝最高加码$rate'
    }
  },
  191: {
    default: 'en-US',
    'vi-VN': {
      activityEntry: 'Hoạt động quà Valentine',
      maxExtraRatio: 'Cộng Kim Cương $rate'
    },
    'en-US': {
      activityEntry: "VALENTINE'S DAY GIFTS",
      maxExtraRatio: 'Bonus: $rate Diamonds'
    },
    'ja-JP': {
      activityEntry: 'バレンタインギフトイベント',
      maxExtraRatio: 'ダイヤ+$rate'
    },
    'ko-KR': {
      activityEntry: '발렌타인데이 스페셜 이벤트',
      maxExtraRatio: '보너스: $rate 다이아'
    },
    'th-TH': {
      activityEntry: "กิจกรรมของขวัญ วาเลนไทน์",
      maxExtraRatio: 'โบนัสเพชร $rate'
    },
    'ru-RU': {
      activityEntry: 'ПОДАРКИ ДНЯ СВ. ВАЛЕНТИНА',
      maxExtraRatio: 'Бонус: $rate Алмазов'
    },
    'zh-TW': {
      activityEntry: '情人節豪禮活動',
      maxExtraRatio: '鑽石加碼$rate'
    },
    'zh-CN': {
      activityEntry: '情人节豪礼活动',
      maxExtraRatio: '钻石加码$rate'
    },
    'de-DE': {
      activityEntry: 'VALENTINSTAG GESCHENKE',
      maxExtraRatio: 'Bonus: $rate Diamanten'
    },
    'fr-FR': {
      activityEntry: 'CADEAUX DE LA SAINT-VALENTIN',
      maxExtraRatio: 'Bonus : $rate Diamants'
    },
    'pt-PT': {
      activityEntry: 'PRESENTES PARA O DIA DOS NAMORADOS',
      maxExtraRatio: 'Bônus: $rate Diamantes'
    },
    'tr-TR': {
      activityEntry: '14 ŞUBAT HEDİYELERİ',
      maxExtraRatio: 'Bonus: $rate Elmas'
    },
    'es-ES': {
      activityEntry: 'REGALOS DE SAN VALENTÍN',
      maxExtraRatio: 'Bonificación: $rate diamantes'
    },
    'it-IT': {
      activityEntry: 'REGALI DI SAN VALENTINO',
      maxExtraRatio: 'Bonus: $rate Diamanti'
    },
    'pl-PL': {
      activityEntry: 'WALENTYNKOWE PREZENTY',
      maxExtraRatio: 'Bonus: $rate Diamentów'
    },
    'id-ID': {
      activityEntry: 'Event Mewah Valentine',
      maxExtraRatio: 'Diamond bonus $rate'
    },
    'ar-SA': {
      activityEntry: 'حدث هدايا عيد الحب',
      maxExtraRatio: 'كلمة السر االماسية$rate'
    }
  }
};

export const getGameLanguage = (lang, key, game) => {
  if (
    !GAME_LANUGAME[game] ||
    !GAME_LANUGAME[game].default ||
    !GAME_LANUGAME[game][GAME_LANUGAME[game].default][key]
  ) {
    return '';
  }

  let realLang =
    GAME_LANUGAME[game][lang] && GAME_LANUGAME[game][lang][key]
      ? lang
      : GAME_LANUGAME[game].default;
  return GAME_LANUGAME[game][realLang][key];
};
